import { memo, useCallback, useMemo } from 'react';
import { claimStatusReward, selectIsClaimingReward } from '../../state/';
import { useDispatch, useSelector } from '@bonanza-social/toolkit/state';
import { Box, Button, Text } from '@bonanza-social/moonlight';
import { useTranslation } from '@bonanza-social/i18n';
import { StatusBoxListItemProps } from './types';
import StatusBoxWithGem from './StatusBoxWithGem';
import { selectBoxCountTransmit } from '@bonanza-social/status/state';
import { BottomSheet } from '@bonanza-social/navigation';
import { useTransmitResolver } from '@bonanza-social/transmit-resolver';

function StatusBoxListItem({ reward, isOnlyItem }: StatusBoxListItemProps) {
  const dispatch = useDispatch();
  const isClaimingReward = useSelector((state) =>
    selectIsClaimingReward(state, reward.rewardId),
  );

  const { shouldTransmit: shouldTransmitResolver } = useTransmitResolver();

  const boxCountRedirect = useSelector(selectBoxCountTransmit);
  const shouldTransmit = boxCountRedirect && shouldTransmitResolver;

  const handleOpen = useCallback(async () => {
    await dispatch(claimStatusReward(reward.rewardId));

    if (isOnlyItem && shouldTransmit) {
      BottomSheet.open({
        namespace: 'status',
        type: 'statusTransmit',
      });
    }

    // TODO: Animate coins
  }, [dispatch, reward.rewardId, isOnlyItem, shouldTransmit]);

  const [t] = useTranslation('status');

  const GiftBoxText = useMemo(
    () =>
      isOnlyItem ? null : (
        <Text
          variant="body-s-semi"
          gradient={`darkSurfaceStatus${reward.sourceType}`}
        >
          {t('status_box_list_item_name', { status: reward.sourceType })}
        </Text>
      ),
    [reward, isOnlyItem, t],
  );

  return (
    <Box
      width="100%"
      flexDirection={isOnlyItem ? 'column' : 'row'}
      gap={isOnlyItem ? 'space-500' : 'space-0'}
      justifyContent="space-between"
      alignItems="center"
    >
      <Box flexDirection="row" gap="space-200" alignItems="center">
        <StatusBoxWithGem
          isOnlyItem={isOnlyItem}
          statusName={reward.sourceType}
        />
        {GiftBoxText}
      </Box>
      <Button
        width={isOnlyItem ? '100%' : 'auto'}
        minWidth={85}
        variant={isOnlyItem ? 'primary' : 'secondary'}
        locNS="status"
        locKey="status_boxes_open_cta"
        onPress={handleOpen}
        loading={isClaimingReward}
      />
    </Box>
  );
}

export default memo(StatusBoxListItem);
